import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import DragDrop from "../DragDrop/DragDrop";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";
function User() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    SiteUserID: 0,
    FirstName: "",
    LastName: "",
    Email: null,
    Mobile: "",
    MobileNo: "",
    TwoFactorAuth: false,
    GetEmailAlerts: false,
    GetSMSAlerts: false,
    ImageURL: "",
    Status: 1,
    SiteRoleID: 0,
  });
  const [screenData, setScreenData] = useState<any>([]);
  const [dropDowndata, setDropDowndata] = useState<any>([]);

  const [linkedRolesData, setLinkedRolesData] = useState<any>([]);
  const [rolesData, setRolesData] = useState<any>([]);

  useEffect(() => {
    LoadUsersData();
  }, []);

  function LoadUsersData() {
    let object = {} as any;
    object.FirstName = "";
    object.LastName = "";
    object.Email = "";
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/LoadUsersData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2[0]);
          thisGridListDataRef.current = deepCopy2[0];
          setScreenData(deepCopy2[0]);

          setDropDowndata(deepCopy1[2]);
          setLinkedRolesData(l_oResponse[1]);
          setRolesData(l_oResponse[2]);

          // console.log(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function InviteUser(SiteUserID: number, BaseCompanyID: number) {
    var data: any = {} as any;
    data.SiteUserID = SiteUserID;
    data.BaseCompanyID = BaseCompanyID;
    setIsAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/AjaxInviteUser", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0][0];

          if (l_oResponse.Status == 1) {
            showSuccessMessage(l_oResponse.Message);
          } else {
            showErrorMessage(l_oResponse.Message);
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.FirstName || addEditObject.FirstName == 0) {
      showErrorMessage("Please select First Name");
      IsOkay = false;
    } else if (!addEditObject.LastName || addEditObject.LastName == 0) {
      showErrorMessage("Please select Last Name");
      IsOkay = false;
    } else if (!addEditObject.Email || addEditObject.Email == "") {
      showErrorMessage("Please select Email");
      IsOkay = false;
    } else if (!addEditObject.SiteRoleID || addEditObject.SiteRoleID == "") {
      showErrorMessage("Please select Role");
      IsOkay = false;
    }

    if (IsOkay == true) {
      SaveFiles();
    }
  }

  function saveScreenData(files: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.SiteUserID = addEditObject.SiteUserID;
    object.FirstName = addEditObject.FirstName;
    object.LastName = addEditObject.LastName;
    object.Email = addEditObject.Email;
    object.Mobile = SelectedMobileNumber; //addEditObject.Mobile;
    object.TwoFactorAuth = addEditObject.TwoFactorAuth;
    object.GetEmailAlerts = addEditObject.GetEmailAlerts;
    object.GetSMSAlerts = addEditObject.GetSMSAlerts;
    object.Status = addEditObject.Status;
    object.RoleIDs = addEditObject.SiteRoleID;

    if (files && files.length > 0) {
      object.ImageURL = files[0].FileURL;
    } else {
      object.ImageURL = addEditObject.ImageURL;
    }

    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/AjaxSaveUserData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0][0].Status == 0) {
            showErrorMessage(l_response[0][0].Message);
          } else {
            setIsAddNew(0);
          }
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.SiteUserID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/AjaxDeleteThisUser", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          SaveFiles();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  // file upload code
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "FirstName")) {
        (
          document.getElementById("imgSort" + "FirstName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "LastName")) {
        (
          document.getElementById("imgSort" + "LastName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Email")) {
        (
          document.getElementById("imgSort" + "Email") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Mobile")) {
        (
          document.getElementById("imgSort" + "Mobile") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");

  useEffect(() => {
    // console.log("Mobile", addEditObject.Mobile);
    SetSelectedMobileNumber(addEditObject.Mobile);
  }, [addEditObject.Mobile, isAddNew]);

  useEffect(() => {
    setAddEditObject((prevState: any) => ({
      ...prevState,
      MobileNo: SelectedMobileNumber,
    }));
  }, [SelectedMobileNumber]);

  //Dragdrop starts
  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 20,
    ObjectType: 20,
    MaxAllowedFiles: 1,
    UploadType: 1,
    FolderName: "User",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(false);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
    // SaveFiles(ChildData);
  }

  function SaveFiles() {
    // call this function for saving attachments, when you get this function responce call actuall function who save data in table.
    // let uploadFileList = UploadFileList;

    if (
      uploadFileList &&
      uploadFileList.length > 0 &&
      !uploadFileList[0].AlreadyUploaded
    ) {
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = 1;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(AppContext.FilesAPI + "api/PTAttachment/SaveFilesData", object)
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            saveScreenData(l_response); // call actuall function who save data in table
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else saveScreenData([]);
  }

  //Dragdrop ends

  function setImageData(item: any) {
    let l_PTUploadedFiles: any = [];
    if (item.ImageURL !== "") {
      let obj: any = {};
      obj.Name = item.ImageURL;
      obj.FileURLDisplay = item.ImageURL;
      obj.FileURL = item.ImageURL;
      obj.AlreadyUploaded = true;
      l_PTUploadedFiles.push(obj);
    }

    setDragDropFeatures((prevState: any) => ({
      ...prevState,
      ObjectID: item.SiteUserID,
      PTUploadedFiles: l_PTUploadedFiles,
    }));

    item.SiteRoleID = 0;
    addEditObject.SiteRoleID = 0;
    if (linkedRolesData.length > 0) {
      for (var i = 0; i < linkedRolesData.length; i++) {
        if (
          linkedRolesData[i].SiteUserID == item.SiteUserID &&
          !linkedRolesData[i].IsDeleted
        ) {
          for (var k = 0; k < rolesData.length; k++) {
            if (linkedRolesData[i].SiteRoleID == rolesData[k].SiteRoleID) {
              rolesData[k].Ticked = true;
              if (item.SiteRoleID == 0) {
                item.SiteRoleID = linkedRolesData[i].SiteRoleID;
              }
            }
          }
        }
      }
      setAddEditObject((prevState: any) => ({
        ...prevState,
        SiteRoleID: item.SiteRoleID,
      }));
    }
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      SiteUserID: 0,
                      FirstName: "",
                      LastName: "",
                      Email: null,
                      Mobile: "",
                      MobileNo: "",
                      TwoFactorAuth: false,
                      GetEmailAlerts: false,
                      GetSMSAlerts: false,
                      ImageURL: "",
                      Status: 1,
                      SiteRoleID: 0,
                    });
                    setIsAddNew(1);
                    SetSelectedMobileNumber("");
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblmover", "User")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblmover">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        First Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "FirstName")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("FirstName")}
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "FirstName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Last Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "LastName")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("LastName")}
                          title={"Sort By LastName"}
                        >
                          <span id={"imgSort" + "LastName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Email
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Email")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Email")}
                          title={"Sort By Email"}
                        >
                          <span id={"imgSort" + "Email"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Mobile
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Mobile")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Mobile")}
                          title={"Sort By Mobile"}
                        >
                          <span id={"imgSort" + "Mobile"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Two Factor Authentication</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.FirstName}</td>
                          <td>{item.LastName}</td>
                          <td>{item.Email}</td>
                          <td>{item.Mobile}</td>
                          <td>
                            {item.TwoFactorAuth == true ? "Enable" : "Disabled"}
                          </td>
                          <td>
                            {item.ImageURL !== "" && (
                              <img
                                src={item.ImageURL}
                                width="25px"
                                height="25px"
                                alt="img"
                              />
                            )}
                          </td>
                          {item.Status == 1 && (
                            <td className="bold-font inv-accep">
                              Invitation Accepted
                            </td>
                          )}
                          {item.Status == 0 && (
                            <td className="bold-font inv-pend">Pending</td>
                          )}
                          {item.Status == 2 && (
                            <td className="bold-font inv-rej">
                              Invitation Rejected
                            </td>
                          )}
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  SetSelectedMobileNumber("");
                                  setAddEditObject({
                                    SiteUserID: item.SiteUserID,
                                    FirstName: item.FirstName,
                                    LastName: item.LastName,
                                    Email: item.Email,
                                    Mobile: item.Mobile,
                                    MobileNo: item.MobileNo,
                                    TwoFactorAuth: item.TwoFactorAuth,
                                    GetEmailAlerts: item.GetEmailAlerts,
                                    GetSMSAlerts: item.GetSMSAlerts,
                                    ImageURL: item.ImageURL,
                                    Status: item.Status,
                                    SiteRoleID: item.SiteRoleID,
                                  });
                                  setImageData(item);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.SiteUserID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>

                              {item.Status == 0 && (
                                <a
                                  onClick={() =>
                                    InviteUser(
                                      item.SiteUserID,
                                      item.FOSCompanyID,
                                    )
                                  }
                                  title="Resend Invitation"
                                >
                                  <img
                                    src="images/envelope.svg"
                                    width="18px"
                                    height="18px"
                                    alt="Edit"
                                  />
                                </a>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-1111 gap-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  First Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.FirstName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      FirstName: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Last Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.LastName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LastName: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Email:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Email}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Email: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Mobile:</span>
                <MobileInput
                  SelectedMobileNumber={SelectedMobileNumber}
                  SetSelectedMobileNumber={SetSelectedMobileNumber}
                />
                {/* <input
                  className="input-field w-100"
                  value={addEditObject.Mobile}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Mobile: e.target.value,
                    }))
                  }
                /> */}
              </div>
{/*
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span style={{ fontSize: "12px", color: "#6b7280" }}>
                  Two Factor Authentication:
                </span>

                <div className="com-toggle">
                  <span className="txt-compare bold-font">No</span>

                  {addEditObject.TwoFactorAuth == false && (
                    <a
                      className="com-btn relative-btn p-relative"
                      onClick={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          TwoFactorAuth: true,
                        }))
                      }
                    >
                      <span></span>
                    </a>
                  )}
                  {addEditObject.TwoFactorAuth == true && (
                    <a
                      className="com-btn com-sel relative-btn p-relative"
                      onClick={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          TwoFactorAuth: false,
                        }))
                      }
                    >
                      <span></span>
                    </a>
                  )}

                  <input
                    type="checkbox"
                    checked={addEditObject.TwoFactorAuth}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        TwoFactorAuth: e.target.checked,
                      }))
                    }
                  /> 

                  <span className="txt-compare bold-font">Yes</span>
                </div>
              </div>
*/}
              {addEditObject.TwoFactorAuth == true && (
                <>
                  <div className="field-input grid-d flex-gap3 flex-js text-left">
                    <span style={{ fontSize: "12px", color: "#6b7280" }}>
                      OTP via SMS:
                    </span>

                    <div className="com-toggle">
                      <span className="txt-compare bold-font">No</span>

                      {addEditObject.GetSMSAlerts == false && (
                        <a
                          className="com-btn relative-btn p-relative"
                          onClick={(e) =>
                            setAddEditObject((prevState: any) => ({
                              ...prevState,
                              GetSMSAlerts: true,
                            }))
                          }
                        >
                          <span></span>
                        </a>
                      )}
                      {addEditObject.GetSMSAlerts == true && (
                        <a
                          className="com-btn com-sel relative-btn p-relative"
                          onClick={(e) =>
                            setAddEditObject((prevState: any) => ({
                              ...prevState,
                              GetSMSAlerts: false,
                            }))
                          }
                        >
                          <span></span>
                        </a>
                      )}
                      <span className="txt-compare bold-font">Yes</span>
                    </div>
                  </div>
                                    <div className="field-input grid-d flex-gap3 flex-js text-left">
                    <span style={{ fontSize: "12px", color: "#6b7280" }}>
                      OTP via Email:
                    </span>

                    <div className="com-toggle">
                      <span className="txt-compare bold-font">No</span>

                      {addEditObject.GetEmailAlerts == false && (
                        <a
                          className="com-btn relative-btn p-relative"
                          onClick={(e) =>
                            setAddEditObject((prevState: any) => ({
                              ...prevState,
                              GetEmailAlerts: true,
                            }))
                          }
                        >
                          <span></span>
                        </a>
                      )}
                      {addEditObject.GetEmailAlerts == true && (
                        <a
                          className="com-btn com-sel relative-btn p-relative"
                          onClick={(e) =>
                            setAddEditObject((prevState: any) => ({
                              ...prevState,
                              GetEmailAlerts: false,
                            }))
                          }
                        >
                          <span></span>
                        </a>
                      )}

                      <span className="txt-compare bold-font">Yes</span>
                    </div>
                  </div>
                </>
              )}
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Assign Role:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.SiteRoleID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SiteRoleID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Role</option>
                  {dropDowndata &&
                    dropDowndata.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.SiteRoleID}>{item.RoleName}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>

              <div className="field-input grid-d g-c-fw">
                <DragDrop
                  ParentFeatures={dragDropFeatures}
                  DragDropCallback={handleDragDropCallback}
                  TriggerChild={triggerChild}
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default User;
